/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromAccess from 'app/shared/store/actions/access.action';
import { ProductDTO } from '@shared/models/product.model';

export interface AccessState {
  loading: boolean;
  success: boolean;
  error: boolean;
  athletes: any[];
  parents: any[];
  products: ProductDTO[];
}

export const initialState = {
  loading: false,
  success: false,
  error: false,
  athletes: [],
  parents: [],
  products: [],
};

export function reducer(state = initialState, action: fromAccess.AccessAction): AccessState {
  switch (action.type) {
    case fromAccess.LOAD_USER_ACCESS: {
      return {
        ...state,
        loading: true,
      };
    }
    case fromAccess.LOAD_USER_ACCESS_FAIL: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    }
    case fromAccess.LOAD_USER_ACCESS_SUCCESS: {
      return {
        ...state,
        athletes: action.payload.athletes,
        parents: action.payload.parents,
        products: action.payload.products,
        loading: false,
        success: true,
        error: false,
      };
    }
    case fromAccess.RESET_USER_ACCESS: {
      return {
        ...initialState,
      };
    }
  }
  return state;
}

export const getAccessState = (state: AccessState) => state;
export const getUserAthletes = (state: AccessState) => state.athletes;
export const getUserAccess = (state: AccessState) => state.products;
